import { cloneElement, Children } from "react";
import cn from "classnames";
import s from "./Tabs.module.scss";

const TabsPanel = ({
  active,
  className,
  changeActiveTab,
  disabled,
  ...props
}) => {
  const childrens = Children.toArray(props.children);
  const classNames = cn(s.tabsPanel, className);
  return (
    <div className={classNames} {...props}>
      {childrens.map((children, index) =>
        cloneElement(children, {
          isActive: index == active,
          tabIndex: index,
          changeActiveTab: (tabIndex) => changeActiveTab(tabIndex),
          key: index,
        })
      )}
    </div>
  );
};

export default TabsPanel;
